import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input",
			},
			{
				prop: "shujly",
				label: '数据来源',
				type: "select",
				selectval: comMapping.$ShujlyMapping
			},
			{
				prop: "zhuancse",
				label: '本期进项税额转出额',
				type: "inputplus"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			}
		],
		searchdata: {
			nsrsbh: "",
			nsrmc: "",
			zhuancse: [],
			shujly: "",
			suosq: ""
		},
		headData: [{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 160,
				custom:true,

			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				custom:true,

			},
			{
				title: "本期进项税额转出额",
				prop: "zhuancse",
				width: 160,
				custom:true,
			},
			{
				title: "数据来源",
				prop: "shujly",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "250",
				custom: true
			},
		],
		tableData: [{
				sfydata: false, //是否有数据
				sfyshenbao: false //是否属于当前申报期
			},
			{
				sfydata: false,
				sfyshenbao: false
			}
		],
		headlyData: [{
				title: "映射规则编码",
				prop: "zhangtCode",
				width: "100"
			},
			{
				title: "相关公司",
				prop: "companyNames",
				custom: true,
				width: 160,
				align: "left"
			},
			{
				title: "数据来源",
				prop: "laiy",
				custom: true,
				width: "300px"
			},
		],
		tablelyData: [{}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		lypagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		hzckInitData: {
			nsrsbh: "",
			suosq: ""
		},
		mxdjInitData: {
			nsrsbh: "",
			suosq: "",
			outId: ""
		},
		headckywData: [{
				title: "项目",
				prop: "zclxmc",
				width: "200"
			},
			{
				title: "档次",
				prop: "lanci",
				width: "200"
			},
			{
				title: "税额",
				prop: "gzcode",
				width: "200"
			}
		],
		tableckywData: [

		],
		tableJson: "{\n" +
			"  \"searchList\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"本期进项税额转出额\",\n" +
			"      \"column\":\"zhuancse\",\n" +
			"      \"originName\":\"本期进项税额转出额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"转出原因\",\n" +
			"      \"column\":\"zhuancyy\",\n" +
			"      \"originName\":\"转出原因\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"headData\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"本期进项税额转出额\",\n" +
			"      \"column\":\"zhuancse\",\n" +
			"      \"originName\":\"本期进项税额转出额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"转出原因\",\n" +
			"      \"column\":\"zhuancyy\",\n" +
			"      \"originName\":\"转出原因\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"formlist\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"本期进项税额转出额\",\n" +
			"      \"column\":\"zhuancse\",\n" +
			"      \"originName\":\"本期进项税额转出额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"转出原因\",\n" +
			"      \"column\":\"zhuancyy\",\n" +
			"      \"originName\":\"转出原因\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ]\n" +
			"}"
	}
	return obj
}
